import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule
} from '@angular/forms';
import { EINVOICE_TYPE } from '@core';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { ViewItemComponent } from 'src/app/shared/components/view-item/view-item.component';

@Component({
  selector: 'app-einvoice-type-select',
  templateUrl: './einvoice-type-select.component.html',
  styles: [],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EInvoiceTypeSelectComponent),
      multi: true
    }
  ],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NzSelectModule,
    ViewItemComponent
  ]
})
export class EInvoiceTypeSelectComponent implements ControlValueAccessor {
  options = [...EINVOICE_TYPE];

  @Input() value: string = '01';
  @Input() disabled = false;
  @Input() allowEdit = true;
  @Input() borderless = false;

  get readonly() {
    if (this.disabled) {
      return true;
    }
    return false;
  }

  get displayText() {
    const item = this.options.find(x => x.value === this.value);
    if (item) return item.name;
    return '';
  }

  onChange: any = () => {};
  onTouched: any = () => {};
  constructor(private cdr: ChangeDetectorRef) {}

  writeValue(value: string): void {
    this.value = value;
    this.onChange(value);
    this.cdr.markForCheck();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onModelChange(val: any) {
    this.value = val;
    this.onChange(val);
    this.cdr.markForCheck();
  }
}
